/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import getImageRenditions from '../../utils/getImageRenditions'
import styles from './styles'
import HeroCard from '../HeroCard'
import { API_IMAGE_OBJECT } from '../../utils/types'
import PreviewPlayerUtils from '../../utils/previewPlayer'

const ProgrammeHeader = ({
  name,
  availableEpisodes,
  image,
  programmeData,
  featuredEpisode,
  programmeGuid,
  isMobile,
  stvLiveData,
  autoplayShortform,
}) => {
  const playerUtils = PreviewPlayerUtils()
  const { swiperRef } = playerUtils
  const isStvLiveProg = stvLiveData?.now?.programme?.guid === programmeGuid

  useEffect(() => {
    playerUtils.checkVisible()
    window.addEventListener('scroll', playerUtils.checkVisible)
    window.addEventListener('message', playerUtils.handleMessage)
    return () => {
      window.removeEventListener('message', playerUtils.handleMessage)
    }
  }, [])

  const progmImages = {
    ...getImageRenditions(programmeData.images[0]?._filepath, (isMobile ? ['1000x1000'] : ['1920x1080'])),
    sizes: '100vw',
    alt: '',
  }

  const programDetails = {
    title: name,
    images: image,
    guid: programmeGuid,
  }
  const accessibility = programmeData?.featuredEpisode?.accessibility
  // because some accessibilitydata not returned in the base programme
  const workaroundAccessibility = programmeData?.accessibility

  const genre = programmeData.genre.name
  const buttonTextLink = featuredEpisode?.link
  const playButton = featuredEpisode?.label === 'Featured' || (availableEpisodes === 1)
  // eslint-disable-next-line no-nested-ternary
  const buttonText = playButton ? 'Play' : (featuredEpisode?.label === 'Latest' ? 'Latest Episode' : featuredEpisode?.label)
  // eslint-disable-next-line no-nested-ternary
  const Episodes = programmeData?.series?.length > 1 ? `${programmeData?.series?.length} series` : ((availableEpisodes > 1 ? `${availableEpisodes} Episodes` : featuredEpisode?.duration || ''))
  return (
    <section className="ProgrammeHeader">
      <div className="hero-container" ref={swiperRef}>
        <HeroCard
          title={name}
          progmImages={progmImages}
          showCTA
          key={programmeData.name}
          specialEvent
          noScale
          recoID={null}
          {...programmeData}
          isStvLiveProg={isStvLiveProg}
          showTitle={false}
          availableEpisodes={Episodes}
          description={programmeData.longDescription}
          programmeHead
          programmeDetails={programDetails}
          isGuidance={featuredEpisode?.hasGuidanceText}
          audioDescribed={
            accessibility?.audioDescription || workaroundAccessibility?.audioDescribed
          }
          visuallySigned={accessibility?.signLanguage || workaroundAccessibility?.visuallySigned}
          isSubtitle={accessibility?.subtitles}
          hasInformation={featuredEpisode?.hasInfoText}
          hasCompetitionText={featuredEpisode?.hasCompetitionText}
          prgmGenre={genre}
          subGenre={programmeData?.genre?.subGenre?.name}
          progmButton={buttonText}
          progmButtonLink={buttonTextLink}
          competitionText={featuredEpisode?.competitionText}
          informationText={featuredEpisode?.informationText}
          autoplayShortform={autoplayShortform}
          playing={playerUtils.previewPlaying}
          inViewScroll={playerUtils.inView}
          userPaused={playerUtils.previewUserPause}
        />
      </div>
      <style jsx>{styles}</style>
    </section>
  )
}

ProgrammeHeader.propTypes = {
  programmeGuid: PropTypes.string,
  name: PropTypes.string.isRequired,
  availableEpisodes: PropTypes.number,
  longDescription: PropTypes.string,
  image: PropTypes.object,
  featuredEpisode: PropTypes.shape({
    duration: PropTypes.string,
    hasInfoText: PropTypes.bool,
  }),
  programmeData: PropTypes.shape({
    images: PropTypes.arrayOf(API_IMAGE_OBJECT),
    featuredEpisode: PropTypes.shape({
      accessibility: PropTypes.object,
      label: PropTypes.string,
      _permalink: PropTypes.string,
    }),
    series: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    genre: PropTypes.shape({
      name: PropTypes.string,
    }),
    longDescription: PropTypes.string,
    name: PropTypes.string,
  }),
}

ProgrammeHeader.defaultProps = {
  programmeGuid: '',
  availableEpisodes: null,
  longDescription: null,
  image: {},
  programmeData: {},
  featuredEpisode: {},
}

export default ProgrammeHeader
